export default class TestSerializer {
  static deSerialize(data) {
    return {
      name: data.payee ? data.payee.name : null
    };
  }
}